import {
  Component,
  Input,
  ViewEncapsulation
} from '@angular/core';

@Component({
    selector: 'reporter-icon',
    templateUrl: './icon.component.html',
    styleUrls: ['./icon.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class IconComponent {

  @Input() size = 18;
  @Input() icon = '';
  @Input() cursorPointer = false;
  @Input() tooltip: string = null;

  constructor() { }
}
